import { getLocalTranslation } from '../../utils/i18nKit';
export var getGreatAmericanBusinessInsuranceQuoteClassAOPQuestionCheckboxInfoMap = {
  usAuthors: {
    title: 'What situations require written releases from persons or organizations?',
    list: [{
      value: 'appearing in photographs or artistic representations',
      label: 'appearing in photographs or artistic representations',
      text: 'appearing in photographs or artistic representations',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'appearing in photographs or artistic representations'
    }, {
      value: 'contributing material to the work',
      label: 'contributing material to the work',
      text: 'contributing material to the work',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'contributing material to the work'
    }, {
      value: 'quoted or paraphrased',
      label: 'quoted or paraphrased',
      text: 'quoted or paraphrased',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'quoted or paraphrased'
    }]
  },
  usClaimAdjusters: {
    title: 'What type(s) of claims does the applicant primarily adjust?',
    list: [{
      value: 'Environmental',
      label: 'Environmental',
      text: 'Environmental',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Environmental'
    }, {
      value: 'Life insurance',
      label: 'Life insurance',
      text: 'Life insurance',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Life insurance'
    }, {
      value: 'Marine',
      label: 'Marine',
      text: 'Marine',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Marine'
    }, {
      value: 'Medical',
      label: 'Medical',
      text: 'Medical',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Medical'
    }, {
      value: 'Personal lines (other than life insurance)',
      label: 'Personal lines (other than life insurance)',
      text: 'Personal lines (other than life insurance)',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Personal lines (other than life insurance)',
      showWhenSelect: true
    }, {
      value: 'Other',
      label: 'Other',
      text: 'Other',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Other',
      showWhenSelect: true
    }]
  },
  usRiskManagement: {
    title: 'What type of consulting services does the applicant primarily provide?',
    list: [{
      value: 'Ecological/green consulting',
      label: 'Ecological/green consulting',
      text: 'Ecological/green consulting',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Ecological/green consulting',
      showWhenSelect: true
    }, {
      value: 'General business operations and strategy',
      label: 'General business operations and strategy',
      text: 'General business operations and strategy',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'General business operations and strategy',
      showWhenSelect: true
    }, {
      value: 'Intellectual property',
      label: 'Intellectual property',
      text: 'Intellectual property',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Intellectual property',
      showWhenSelect: true
    }, {
      value: 'Logistics management',
      label: 'Logistics management',
      text: 'Logistics management',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Logistics management',
      showWhenSelect: true
    }, {
      value: 'Organizational structure',
      label: 'Organizational structure',
      text: 'Organizational structure',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Organizational structure',
      showWhenSelect: true
    }, {
      value: 'Project management',
      label: 'Project management',
      text: 'Project management',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Project management',
      showWhenSelect: true
    }, {
      value: 'Sarbanes-Oxley compliance',
      label: 'Sarbanes-Oxley compliance',
      text: 'Sarbanes-Oxley compliance',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Sarbanes-Oxley compliance',
      showWhenSelect: true
    }, {
      value: 'Safety or Security policies and procedures',
      label: 'Safety or Security policies and procedures',
      text: 'Safety or Security policies and procedures',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Safety or Security policies and procedures',
      showWhenSelect: true
    }, {
      value: 'Business continuity planning/disaster recovery',
      label: 'Business continuity planning/disaster recovery',
      text: 'Business continuity planning/disaster recovery',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Business continuity planning/disaster recovery',
      showWhenSelect: true
    }, {
      value: 'Other',
      label: 'Other',
      text: 'Other',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Other',
      showWhenSelect: true
    }]
  },
  usConsultantHuman: {
    title: 'What type of HR consulting services does the applicant primarily provide?',
    list: [{
      value: 'Employee training and development',
      label: 'Employee training and development',
      text: 'Employee training and development',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Employee training and development',
      showWhenSelect: true
    }, {
      value: 'Legal compliance (including employment practices)',
      label: 'Legal compliance (including employment practices)',
      text: 'Legal compliance (including employment practices)',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Legal compliance (including employment practices)',
      showWhenSelect: true
    }, {
      value: 'Other',
      label: 'Other',
      text: 'Other',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Other',
      showWhenSelect: true
    }]
  },
  usMarketResearchFirm: {
    title: 'What industries does the applicant offer services to?',
    list: [{
      value: 'Financial Institutions/Investment Firms',
      label: 'Financial Institutions/Investment Firms',
      text: 'Financial Institutions/Investment Firms',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Financial Institutions/Investment Firms'
    }, {
      value: 'Legal',
      label: 'Legal',
      text: 'Legal',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Legal'
    }, {
      value: 'Medical',
      label: 'Medical',
      text: 'Medical',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Medical'
    }, {
      value: 'Safety',
      label: 'Safety',
      text: 'Safety',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Safety'
    }, {
      value: 'Security',
      label: 'Security',
      text: 'Security',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Security'
    }, {
      value: 'Other',
      label: 'Other',
      text: 'Other',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Other',
      showWhenSelect: true
    }]
  }
};
export var getGreatAmericanBusinessInsuranceQuoteQuestionInfoMap = function getGreatAmericanBusinessInsuranceQuoteQuestionInfoMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    greate_american_us_quick_journey_criteria: {
      title: 'Quick journey criteria',
      descTitle: [{
        text: 'If you are a independent contractor who meet the below criteria, you can use our quick quote journey.'
      }, {
        text: 'Do you agree with all statements below?'
      }],
      confirmType: '1',
      spec: [{
        list: [{
          text: 'Your work does not require you or any staff to be licensed, certified, or accredited in their field.'
        }, {
          text: 'You have written contracts with clients for all of your work.'
        }, {
          text: 'All of your contracts include a limitation of liability clause.'
        }, {
          text: 'All of your contracts define scope of services.'
        }, {
          text: 'You do not use subcontractors to conduct your work.'
        }, {
          text: 'You have not had any professional liability claims, including open claims, in the past 5 years.'
        }, {
          text: 'There has not been a purchase or merger with another entity within the past five years.'
        }]
      }]
    },
    greate_american_us_reviewed_by_legal_counsel: {
      title: 'Are contracts reviewed by legal counsel?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_written_or_standard_operating_procedures: {
      title: 'Do you maintain written manuals or standard operating procedures?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_work_require_certified: {
      title: 'Does your work require you or any staff to be licensed, certified, or accredited in their field?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_limitation_liability_contract: {
      title: 'Do contracts include a limitation of liability clause?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_contracts_define_scope_services: {
      title: 'Do all of your contracts define scope of services?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_revenue_from_single_client: {
      title: 'Does more than 50% of your revenue come from a single client?',
      confirmType: '2',
      spec: []
    },
    great_american_us_associations_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT create, develop, aggregate or publish standards or specifications.'
        }, {
          text: 'You DO NOT provide accreditation/certification services in Health Care, Legal or Skilled Trades.'
        }]
      }]
    },
    great_american_us_advertising_agencies_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT provide services pertaining to gambling, lottery, sweepstakes, pornography, alcohol, tobacco, cannabis, biotech, pharma and/or medical devices.'
        }]
      }]
    },
    great_american_us_alternative_arbitrators_mediators_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You HAVE NOT served as a fiduciary, director, officer, partner or trustee for any client or owned an equity or financial interest in any client.'
        }, {
          text: 'You DO NOT handle matters involving community disputes, divorces and/or adolescent family court.'
        }]
      }]
    },
    great_american_us_answering_services_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You comply with applicable federal, state, and local laws and regulations relating to telemarketing and tele-sales including “Do Not Call” laws and regulations.'
        }]
      }]
    },
    great_american_us_auctioneer_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You only auction general merchandise (no real property).'
        }, {
          text: 'You DO NOT perform any appraisal services of items to be auctioned.'
        }, {
          text: 'You DO NOT auction merchandise owned by the applicant or any principal or any other entity in which the applicant or principal has controlling financial interest.'
        }]
      }]
    },
    great_american_us_authors_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'Written releases are obtained from persons or organizations:',
          list: getGreatAmericanBusinessInsuranceQuoteClassAOPQuestionCheckboxInfoMap.usAuthors.list
        }]
      }]
    },
    great_american_us_billing_services_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You follow, enforce and comply with data and privacy rules with respect to Personally Identifiable Information (PII).'
        }]
      }]
    },
    great_american_us_bookkeeper_record_keeping_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT provide any of the following services:',
          list: [{
            text: 'Investment advice'
          }, {
            text: 'Legal advice, opinions or law interpretation'
          }, {
            text: 'Prepare compilations, reviews, audits or financial statements'
          }, {
            text: 'Receive or disburse funds'
          }]
        }]
      }]
    },
    great_american_us_call_center_telemarketing_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT provide services to any of the following:',
          list: [{
            text: 'Alarm monitoring'
          }, {
            text: 'Crisis Centers'
          }, {
            text: 'Emergency medical answering services'
          }, {
            text: 'Give advice regarding areas under construction and proximity to utility lines'
          }]
        }]
      }]
    },
    great_american_us_claim_adjusters_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT primarily adjust the following claim types:',
          list: getGreatAmericanBusinessInsuranceQuoteClassAOPQuestionCheckboxInfoMap.usClaimAdjusters.list
        }]
      }]
    },
    great_american_us_concierge_services_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT provide Financial or investment advice.'
        }]
      }]
    },
    great_american_us_consultant_general_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT provide any of the following services:',
          list: [{
            text: 'Architectural, engineering or construction'
          }, {
            text: 'Credit counseling'
          }, {
            text: 'Financing or financial auditing'
          }, {
            text: 'Investment or tax advice'
          }, {
            text: 'Insurance placement or advice'
          }, {
            text: 'Intellectual property'
          }, {
            text: 'Law enforcement training'
          }, {
            text: 'Legal advice'
          }, {
            text: 'Medical advice'
          }, {
            text: 'Mergers/acquisitions or business valuations'
          }, {
            text: 'Real Estate or Property Management'
          }, {
            text: 'Safety or Security policies and procedures'
          }, {
            text: 'Pharmaceutical/Healthcare'
          }]
        }]
      }]
    },
    great_american_us_consultant_computer_it_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT manufacture, design, or assist in the design of any hardware or components.'
        }, {
          text: 'You DO NOT create, support, or work on software that executes securities transactions, makes medical diagnoses, or is involved in manufacturing or process control.'
        }]
      }]
    },
    great_american_us_risk_management_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You primarily provide consulting services for General Business Operations and Strategy, Organizational Structure or Project Managent.',
          list: getGreatAmericanBusinessInsuranceQuoteClassAOPQuestionCheckboxInfoMap.usRiskManagement.list
        }]
      }]
    },
    great_american_us_consultant_human_resources_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You primarily provide HR consulting services for employee training and development.',
          list: getGreatAmericanBusinessInsuranceQuoteClassAOPQuestionCheckboxInfoMap.usConsultantHuman.list
        }]
      }]
    },
    great_american_us_court_reporters_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You have a process to maintain backup copies of recorded information.'
        }]
      }]
    },
    great_american_us_credit_counseling_services_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT operate a collection agency or are affiliated with one.'
        }, {
          text: 'You DO NOT provide legal advice, render opinions or otherwise interpret tax laws or rulings or accounting rules, standards or principles.'
        }, {
          text: 'You DO NOT consult on means or methods of obtaining funds.'
        }]
      }]
    },
    great_american_us_document_preparation_services_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT provide documents that support or provide any of the following services:',
          list: [{
            text: 'Background checks'
          }, {
            text: 'Investment or tax advice'
          }, {
            text: 'Mergers and acquisitions or business valuations'
          }, {
            text: 'Private investigations'
          }]
        }]
      }]
    },
    great_american_us_executive_coach_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT conduct any of the following activities:',
          list: [{
            text: 'Medical counseling (in-patient or out-patient)'
          }, {
            text: 'Substance abuse counseling'
          }, {
            text: 'Social work'
          }, {
            text: 'Family/marriage counseling'
          }]
        }, {
          text: 'You maintain current and valid professional certifications or designations as required or recognized by industry standards.'
        }]
      }]
    },
    great_american_us_executive_search_firms_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You conduct a prior employment check on all candidates.'
        }, {
          text: 'You conduct criminal background checks on all candidates.'
        }]
      }]
    },
    great_american_us_graphic_artist_design_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT own, host or run any website that:',
          list: [{
            text: 'contains any pornographic material'
          }, {
            text: 'contains user generated content'
          }, {
            text: 'is a social networking website'
          }]
        }, {
          text: 'You require clients to sign a final acceptance.'
        }, {
          text: 'You have a process in place to screen materials for any potential violations of another party’s copyrights, trademarks or other intellectual property rights.'
        }]
      }]
    },
    great_american_us_interim_management_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT offer management services in any of the following industries:',
          list: [{
            text: 'Environmental/Chemical/Nuclear/Hazardous Waste/Gas or Oil'
          }, {
            text: 'Farm/Crop Management'
          }, {
            text: 'Financial Institutions/Investment Firms'
          }, {
            text: 'Legal'
          }, {
            text: 'Medical'
          }, {
            text: 'Safety'
          }, {
            text: 'Security'
          }]
        }]
      }]
    },
    great_american_us_interior_decorator_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT provide any of the following services or subcontract any of the following services:',
          list: [{
            text: 'Building contractor/build-out'
          }, {
            text: 'Engineering'
          }]
        }, {
          text: '100% of your services considered non-structural (i.e. the applicant does not, directly or indirectly: advise, recommend, direct, organize, manage, execute or make structural, construction or architectural design changes to any real property).'
        }, {
          text: 'When required, you have procedures in place to be compliant with the Americans with Disabilities Act (ADA) of 1990.'
        }, {
          text: 'NONE of your projects have a construction value of more than $5,000,000.'
        }]
      }]
    },
    great_american_us_interpreter_translator_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT have clients that work in any of the following industries:',
          list: [{
            text: 'Financial'
          }, {
            text: 'Legal'
          }, {
            text: 'Medical advice'
          }, {
            text: 'Real Estate'
          }]
        }]
      }]
    },
    great_american_us_market_research_firms_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT offer services to any of the following industries:',
          list: getGreatAmericanBusinessInsuranceQuoteClassAOPQuestionCheckboxInfoMap.usMarketResearchFirm.list
        }]
      }]
    },
    great_american_us_medical_billing_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You follow and enforce data and privacy rules with respect to Personally Identifiable Information (PII) and Protected Health Information (PHI) as set forth in the Health Insurance Portability and Accountability Act (HIPAA) and other related state and local laws and regulations.'
        }]
      }]
    },
    great_american_us_printers_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'Your activities DO NOT involve the distribution and/or redemption of coupons, rebates or other promotional game tickets.'
        }, {
          text: 'Your activities DO NOT involve the design of logos or trademarks.'
        }, {
          text: 'You require clients to approve proof copies before printing.'
        }, {
          text: 'Your activities DO NOT involve printing of any corporate or financial material (i.e., annual reports, prospectus, stock reports).'
        }]
      }]
    },
    great_american_us_public_relations_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT promote gambling, pornography, alcohol, cannabis or medical related entities.'
        }, {
          text: 'Your contracts clearly state the ownership rights, licensing, and use of any materials or intellectual property created for or during an engagement.'
        }, {
          text: 'Your contracts state that to the best of your knowledge any materials or intellectual property created are original and do not infringe upon the intellectual property rights of others.'
        }]
      }]
    },
    great_american_us_services_temp_help_declaration: {
      title: '',
      confirmType: '1',
      spec: [{
        list: [{
          text: 'You DO NOT perform placement activities for any of the following industries:',
          list: [{
            text: 'Construction'
          }, {
            text: 'Correctional facilities'
          }, {
            text: 'Law enforcement'
          }, {
            text: 'Maritime'
          }, {
            text: 'Medical (nurses, doctors, dentists, etc.)'
          }, {
            text: 'Mental health institutions'
          }, {
            text: 'Trucking'
          }, {
            text: 'Machine/equipment operators'
          }]
        }]
      }]
    },
    greate_american_us_class_advertising_agencies_question: {
      title: 'Do you perform in-house printing?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_answering_services_question_1: {
      title: 'Do you maintain logs of calls made and logs of received and delivered messages?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_answering_services_question_2: {
      title: 'Do you disclose that calls may be recorded?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_auctioneer_question: {
      title: 'Do you provide any written guarantee relating to authenticity or condition of properties auctioned?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_authors_question_1: {
      title: 'For any work of non-fiction incorporating living persons or events, have sources of information and material facts been documented?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_authors_question_2: {
      title: 'Does your publisher have an in-house legal department or outside legal counsel ‘vet’ or review work prior to publication?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_bookkeeper_record_keeping_question_1: {
      title: 'Do you always use engagement letters, service agreements or some other written documentation of the services which are to be provided to the customer/client?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_bookkeeper_record_keeping_question_2: {
      title: 'During the past three (3) years, has the applicant provided services to any publicly held client or high-net-worth individuals (>$10M in total assets)?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_consultant_computer_question: {
      title: 'Does the applicant or any subsidiary provide computer consulting services, including software, hardware, systems, telecommunication analysis or systems integration services?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_court_reporters_question: {
      title: 'If you perform stenographic and/or voice writing transcriptions, have you created and maintained a customized computer dictionary for keystroke code and/or voice file translation?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_expert_witness_question: {
      title: 'Do any of the applicant’s employees testify at judicial, administrative, arbitration or other proceedings?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_interpreter_translator_question: {
      title: 'Do you maintain current and valid professional certifications or designations as required or recognized by industry standards?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_notary_services_question: {
      title: 'Does the applicant provide record storage or document management services for a third party?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_public_relations_question: {
      title: 'Do you have a process in place to screen materials for potential libel, slander or advertising injury?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_staffing_temp_help_question_1: {
      title: 'Does the applicant lease employees or provide employees on secondment to other organizations?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_class_staffing_temp_help_question_2: {
      title: 'Do you conduct background checks prior to placement?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_conducted_by_subcontractors: {
      title: 'Does any of your work being conducted by subcontractors?',
      confirmType: '2',
      spec: []
    },
    greate_american_us_past_professional_liability_claims: {
      title: 'In the past 5 years, have you had any professional liability claims including open claims?',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    greate_american_us_class_authors_declaration_1: {
      subTitle: 'You DO NOT undertake any Pharmaceutical/Healthcare or Religious work?',
      confirmType: '1',
      spec: []
    },
    greate_american_us_class_claim_adjusters_declaration_1: {
      subTitle: 'You DO NOT function as a public adjuster?',
      confirmType: '1',
      spec: []
    },
    greate_american_us_purchase_merger_supplement: {
      title: 'Has there been a purchase or merger with another entity within the past five years?',
      confirmType: '2',
      spec: [],
      reverse: true
    }
  };
};